/* global window */

import { defineComponent, onMounted } from 'vue'

import PointPage from '@/organizations/_default/point'

export default defineComponent({
  extends: PointPage,
  setup(props, context) {
    const page = PointPage.setup(props, context)

    onMounted(() => {
      const telLinks = window.document.querySelectorAll('a[href^="tel:"]')

      telLinks.forEach((element) => {
        if (!(element instanceof window.HTMLAnchorElement)) {
          return
        }

        element.addEventListener('click', () => {
          storelocator.analytics.client?.send('TapToCall', {
            PointName: page.point.value?.name,
            PointKey: page.point.value?.key,
            TelLabel: element.dataset.telLabel || '',
            TelNumber: element.dataset.telNumber || element.getAttribute('href')?.replace(/^tel:/, '') || '',
          })
        })
      })
    })

    return page
  }
})
